import React from "react";
import "./Faq_have_question.css";

function Faq_have_question() {
  return (
    <>
      <section className="Faq_have_question">
        <div className="custom_container">
          <div className="taxt_holder">
            <div>
              <h1>Have A Question?</h1>

              <p>
                To learn more about our expertise, services, and the measures we
                take to ensure the security and confidentiality of your data,
                please contact us.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq_have_question;
